var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "dialog-class": "dialog-class",
      "centered": ""
    },
    on: {
      "hidden": function () {
        _vm.$emit('update:isShow', false);
      },
      "shown": _vm.openForm
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function (_ref) {
        var close = _ref.close;
        return [_c('h4', {
          staticClass: "mb-0 text-primary"
        }, [_vm._v(" " + _vm._s(_vm.$t(_vm.data ? "ar_client_update_group_user" : "ar_client_add_group_user")) + " ")]), _c('ez-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "icon": "ezAr-icon-x",
            "size": "24",
            "color": "#114A9F"
          },
          on: {
            "click": function ($event) {
              return close();
            }
          }
        })];
      }
    }, {
      key: "modal-footer",
      fn: function () {
        return [_c('b-button', {
          attrs: {
            "disabled": _vm.isLoading,
            "variant": "primary"
          },
          on: {
            "click": _vm.createUpdateGroupUser
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("ar_common_save")) + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.isShow,
      callback: function ($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_c('FormItems', {
    ref: "formRef",
    attrs: {
      "items": _vm.formItems,
      "formData": _vm.formData
    },
    on: {
      "update:formData": function ($event) {
        _vm.formData = $event;
      },
      "update:form-data": function ($event) {
        _vm.formData = $event;
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }